"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var filterOutOfStock_1 = require("helpers/filterOutOfStock");
var FeaturedProducts = /** @class */ (function (_super) {
    __extends(FeaturedProducts, _super);
    function FeaturedProducts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturedProducts.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, data = _b.data, section = _b.section;
        var settings = section.settings, blocks = section.blocks;
        var article = data.template && data.template.name == "article";
        var products = blocks
            ? filterOutOfStock_1.filterOutOfStock((_a = blocks.filter(function (item) { var _a, _b, _c; return (_c = (_b = (_a = item) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.title; })) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.settings.product; }))
            : [];
        var collection = settings && settings.collection ? settings.collection : null;
        var collectionProducts = collection && filterOutOfStock_1.filterOutOfStock(settings.collection.products);
        var count = products.length
            ? products.length
            : collection && collectionProducts && collectionProducts.length
                ? collectionProducts.length
                : 0;
        var limit = settings && settings.limit ? settings.limit : 4;
        var max = limit < count ? limit : count;
        var alignment = settings && settings.alignment ? settings.alignment.toLowerCase() : article ? "left" : "center";
        var foreground = settings && settings.foreground ? settings.foreground.toLowerCase() : "midnight";
        var background = settings && settings.background ? settings.background.toLowerCase() : "arctic";
        var sliderSettings = {
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: !!this.props.simple,
            arrows: true,
            infinite: !this.props.simple,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            slidesToShow: 4,
            speed: 400,
            appendDots: function (dots) { return (React.createElement("div", null,
                React.createElement("div", { className: "slick-dots absolute pin-b pin-x flex justify-center max-w-1/2 mx-auto", style: { bottom: "16px" } },
                    React.createElement("ul", { className: "text-center list-reset flex flex-row" }, dots)))); },
            customPaging: function (i) { return (React.createElement("button", { className: "md:hidden block rounded-full bg-secondary-blue-grey border border-transparent outline-none focus:outline-none p-0-3 transition" })); },
            prevArrow: (React.createElement("button", null,
                React.createElement("span", { className: "flex justify-center items-center p-1 text-arctic hover:opacity-75 transition-fast w-4-8 h-4-8 bg-accent-primary rounded-full" },
                    React.createElement(Snippets.Svg, { name: "chevron-left", width: 12 })))),
            nextArrow: (React.createElement("button", null,
                React.createElement("span", { className: "flex justify-center items-center p-1 text-arctic hover:opacity-75 transition-fast w-4-8 h-4-8 bg-accent-primary rounded-full" },
                    React.createElement(Snippets.Svg, { name: "chevron-right", width: 12 })))),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        };
        return (products && products.length) || (collection && collectionProducts && collectionProducts.length) ? (React.createElement("section", { className: "dynamic-products text-" + foreground + " bg-" + background + (settings.verticalspacing ? " py-3-2 md:py-6-4" : "") + (article ? " my-3-2 md:my-6-4" : "") },
            React.createElement(Snippets.Container, { width: "xl", className: "mlg:px-11 md:px-2-4 px-1-6" },
                settings.title || settings.content ? (React.createElement("div", { className: "flex mb-1-4 text-" + alignment + (article ? " md:mb-1-6" : "") },
                    settings.title ? (React.createElement(Snippets.Heading, { size: "h3", tag: "h3", className: "font-semibold text-heading-inverse flex-grow leading-none " + (settings.content ? " mb-0-4" : "") }, settings.title)) : null,
                    React.createElement("a", { href: collection.url, className: "uppercase items-center text-link-inverse font-semibold text-base hidden md:flex" },
                        React.createElement("span", null, "Shop " + collection.title),
                        React.createElement("span", { className: "flex h-1-8 -mt-0-3" },
                            React.createElement(Snippets.Svg, { name: "chevron-right", width: 12, className: "block transition-fast ml-0-6" }))))) : null,
                React.createElement("div", { className: "" + (!article ? " pb-2-3 md:pb-0" : "") },
                    React.createElement("div", { className: "lg:justify-between md:my-0" }, products && products.length ? (products
                        .slice(0, max)
                        .map(function (product, i) { return (React.createElement(Snippets.ProductCard, __assign({ key: i, product: product, simple: true, innerClassName: "w-3/5-w md:w-full shadow-block", className: "px-0-8 md:px-1-2 py-1-6 w-full shadow-block " + (max == 6 ? "md:w-1/3 lg:w-1/" + max + " lg:py-0" : "md:w-1/" + max + " md:py-0") }, _this.props))); })) : collectionProducts && collectionProducts.length ? (React.createElement(Snippets.Slider, { className: "slick-arrows pb-3-5 md:pb-0", settings: __assign({}, sliderSettings) }, collectionProducts.slice(0, max).map(function (product, i) { return (React.createElement(Snippets.ProductCard, __assign({ key: i, product: product, simple: true, innerClassName: "md:w-full bg-arctic px-1-6 py-2 shadow-block", className: "py-1-6 w-full" }, _this.props))); }))) : ([])),
                    !this.props.simple && (React.createElement("a", { href: collection.url, className: "flex md:mt-2-4 uppercase justify-center items-center text-link-inverse font-bold text-base md:hidden" },
                        React.createElement("span", null, "Shop " + collection.title),
                        React.createElement("span", { className: "flex h-1-8 -mt-0-3" },
                            React.createElement(Snippets.Svg, { name: "chevron-right", width: 12, className: "block transition-fast ml-0-6" })))))))) : (products && products.length == 0) || (collection && collectionProducts && collectionProducts.length == 0) ? (React.createElement("section", { className: "dynamic-products" },
            React.createElement(Snippets.Container, { width: "xl", className: "mlg:px-11 md:px-2-4 px-1-6 mb-3-2" },
                React.createElement("p", null, "No Products")))) : (React.createElement("section", { className: "dynamic-products" },
            React.createElement(Snippets.Container, { width: "xl", className: "mlg:px-11 md:px-2-4 px-1-6 mb-3-2" },
                React.createElement("div", { className: "flex flex-row" },
                    React.createElement("div", { className: "w-full md:w-1/4 px-1-6 h-33-6 content-placeholder" }),
                    React.createElement("div", { className: "w-full md:w-1/4 px-1-6 h-33-6 content-placeholder" }),
                    React.createElement("div", { className: "w-full md:w-1/4 px-1-6 h-33-6 content-placeholder" }),
                    React.createElement("div", { className: "w-full md:w-1/4 px-1-6 h-33-6 content-placeholder" })))));
    };
    FeaturedProducts.sectionId = "prods";
    return FeaturedProducts;
}(React.PureComponent));
exports.FeaturedProducts = FeaturedProducts;
